const doc = [({"en":({"js":({"admin":({"sheet_layout_boxes":({"edit_modal":({"edit_box_icon":({"add_box_to_row":"Add box to row", "edit_box":"Edit box"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;